mutation UpdateContents($ids: [ID!]!, $input: UpdateContentsInput!) {
  updateContents(ids: $ids, input: $input) {
    id
    publishAt
  }
}
